import { render, staticRenderFns } from "./BdoMerchantId.vue?vue&type=template&id=5161103c&scoped=true"
import script from "./BdoMerchantId.vue?vue&type=script&lang=js"
export * from "./BdoMerchantId.vue?vue&type=script&lang=js"
import style0 from "./BdoMerchantId.vue?vue&type=style&index=0&id=5161103c&prod&lang=scss&scoped=true"
import style1 from "./BdoMerchantId.vue?vue&type=style&index=1&id=5161103c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161103c",
  null
  
)

export default component.exports